import { Avatar as AvatarBase, AvatarProps, styled } from '@mui/material';

export const Avatar = styled(({ ...props }: AvatarProps) => <AvatarBase {...props} />)`
  font-size: 12px;
  height: 40px;
  width: 40px;
  margin: 25% 25%;
`;
